import { render, staticRenderFns } from "./FaqCategoryDetail.vue?vue&type=template&id=37444068&scoped=true&"
import script from "./FaqCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategoryDetail.vue?vue&type=style&index=0&id=37444068&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37444068",
  null
  
)

export default component.exports